import axios from 'axios'
import modulesDriversLoader from '../services/ModulesDriversLoader'

export default class CommonService {
    constructor() {
        modulesDriversLoader.load().then(({ getApiRoutes }) => {
            this.apiRotues = { ...getApiRoutes() }
        })
    }

    async fetchAnalystAndAdminAnalystList(payload = {}) {
        const response = await axios.post(
            this.apiRotues.API_URL_GET_ANALYST_AND_ADMIN_LIST,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`
                }
            }
        )

        return response.data?.data
    }

    async fetchCountriesList() {
        const response = await axios.post(this.apiRotues.API_URL_FETCH_COUNTRIES_LIST, {
            headers: {
                Authorization: `Bearer ${window.localStorage.getItem(
                    'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                )}`
            }
        })

        return response.data.data
    }
}
